import React, { useEffect, useState } from "react";
import privateRequest from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import Select from "react-select";
import moment from "moment";
import { useSocket } from "../SocketContext";

export default function ({
  id,
  assign,
  jobId,
  amount,
  tip,
  code,
  fixedComment,
  adminName,
  action,
  actionsPass,
  selectedGroup,
  userId
}) {
  const [provider, setProvider] = useState();
  const [selectedProviders, setSelectedProviders] = useState();
  const [comment, setComment] = useState("");
  const [jobData, setJobData] = useState();
  const [cancelCode, setCancelCode] = useState();
  const [slotDates, setSlotDates] = useState();
  const [slotData, setSlotData] = useState();
  const [slotsPreview, setSlotsPreview] = useState();
  const [selectedSlot, setselectedSlot] = useState();
  const [selectedTip, setSelectedTip] = useState(tip);
  const [paymentMode, setPaymentMode] = useState();
  const [response, setResponse] = useState();
  const [showSp, setshowSp] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [amountt, setAmountt] = useState(0);
  const [slotLoading, setSlotLoading] = useState(false);
  const { sendJobId, isConnected } = useSocket();

  console.log("selectedSlot", selectedSlot);
  console.log("slotDates", slotDates);
  console.log("slotData", slotData);
  console.log("showSp", showSp);

  const getServiceProviderData = async (id) => {
    try {
      const response = await privateRequest.get(
        `ServiceProvider/GetProviderBystatus`
      );
      console.log("response?.data?", response?.data.data);
      setProvider(response?.data.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const getUsers = async () => {
    try {
      const response = await privateRequest.get(`jobs/getJobsById/${id}`);
      console.log("jobs", response?.data?.data?.jobs);
      setJobData(response?.data?.data?.jobs);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  // useEffect(()=>{
  //   alert(selectedGroup)
  // },[])

  // const ServiceProviderActions = async (dataa) => {
  //   try {
  //     const response = await privateRequest.post(`jobs/updateAssign`, dataa);
  //     console.log("response of action", response?.data.data);
  //     Swal.fire("Status updated successfully", "success");

  //     setResponse(response);
  //     actionsPass(response);
  //     setComment();
  //     setselectedSlot();
  //     setPaymentMode();
  //     setSelectedTip(0);
  //     setCancelCode();
  //     selectedProviders();
  //     setSlotDates();
  //   } catch (error) {
  //     console.error("Error fetching parent category groups:", error);
  //     Swal.fire("Status updated successfully", error);
  //   }
  // };

  const ServiceProviderActions = async (dataa) => {
    try {
      console.log("dataa", dataa);
      const response = await privateRequest.post(`jobs/updateAssign`, dataa);
      navigator.clipboard.writeText(JSON.stringify(dataa));
      
      
      

      if (isConnected) {
        sendJobId(JSON.stringify(dataa));

        
      }
      Swal.fire("Success", response?.data?.message, "success");

      setResponse(response);
      actionsPass(response);
      console.log("response of provider", response);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        // text: "Error creating Order",
        text: error.response?.data?.message,
      });
    }
  };
  const updatedData = slotsPreview?.map((item) => {
    const updatedSlotTime = item.slotTime.replace(/(AM|PM)/, "");
    return { ...item, slotTime: updatedSlotTime };
  });

  useEffect(() => {
    getServiceProviderData();
    getUsers();
  }, []);

  useEffect(() => {
    if (response?.data) {
      setComment("");
      setselectedSlot(null);
      setPaymentMode(null);
      setSelectedTip(0);
      setCancelCode(null);
      setSelectedProviders(null);
    }
  }, [response?.data]);

  const handleSelectChange = (selectedOptions) => {
    setSelectedProviders(selectedOptions);
  };
  const getSlots = async (date, PcatId) => {
    console.log(date, PcatId);
    try {
      setSlotLoading(true);
      let url = `AppoinmentSlot/SlotByParentId?date=${date}&PcatgroupId=${PcatId}`;
      const response = await privateRequest.get(url);
      setSlotData(response?.data?.data[0]?.slot);
      setSlotsPreview(response?.data?.data[0]?.slot);
      console.log("response?.data[0]?.slot", response?.data?.data[0]?.slot);
      setSlotLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (selectedGroup && selectedDate) {
      getSlots(selectedDate, selectedGroup);
    }
  }, [selectedGroup, selectedDate]);

  // const getSlots = async () => {
  //   try {
  //     let url = `AppoinmentSlot/GetAppoinmentSlot`;
  //     const response = await privateRequest.get(url);
  //     console.log("responseofslots", response?.data?.data);
  //     let dates = response?.data?.data.map((item) => item?.slotDate);
  //     setSlotDates(dates);
  //     setSlotData(response?.data?.data);
  //     console.log("dates", dates);
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  // useEffect(() => {
  //   getSlots();
  // }, []);

  console.log("slotsPreview", slotsPreview);

  return (
    <div>
      <div
        className="modal fade"
        id="ressignSPModal"
        data-backdrop="static"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                <i className="fas fa-bullseye"></i> {assign} SP
              </h5>
              <button
                onClick={() => {
                  setComment("");
                  setSelectedProviders(null);
                }}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form id="assign_sp" className="needs-validation" novalidate>
              <div className="modal-body">
                <div className="form-group">
                  <label>Select SP</label>

                  <Select
                    isClearable
                    options={provider?.map((option) => ({
                      value: option._id,
                      label: option.Name,
                    }))}
                    onChange={handleSelectChange}
                    value={selectedProviders}
                  />
                </div>
                <div className="form-group">
                  <label>Comment</label>
                  <textarea
                    value={comment}
                    onChange={(e) => {
                      setComment(e.target.value);
                      console.log("textarea", e);
                    }}
                    className="form-control"
                    name="assignComment"
                    id="assignComment"
                    placeholder="Add Comment"
                    rows="4"
                  ></textarea>
                </div>
                <input type="hidden" value="assign_sp" name="action" />
                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-warning mr-2 mr-2"
                    data-dismiss="modal"
                  >
                    Close
                  </button>

                  {assign == "Assign" ? (
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(JSON.stringify(userId));
                        let dataa = {
                          jobId: jobId,
                          action: "assigned",
                          reasons: comment,
                          jobAssignSProviderId: selectedProviders?.value,
                          types: "admin",
                          SPName: selectedProviders?.label,
                          userId:userId
                        };

                        ServiceProviderActions(dataa);
                      }}
                      type="button"
                      name="ReassignSP"
                      className="btn btn-primary mr-2 mr-2"
                      data-dismiss="modal"
                    >
                      {assign}
                    </button>
                  ) : (
                    <button
                      onClick={() => {
                        navigator.clipboard.writeText(JSON.stringify(userId));

                        let dataa = {
                          jobId: jobId,
                          action: "reassigned",
                          reasons: comment,
                          jobAssignSProviderId: selectedProviders?.value,
                          types: "admin",
                          SPName: selectedProviders?.label,
                          userId:userId
                        };
                        ServiceProviderActions(dataa);
                      }}
                      type="button"
                      name="ReassignSP"
                      className="btn btn-primary mr-2 mr-2"
                      data-dismiss="modal"
                    >
                      {assign}
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="resheduleJobModal"
        data-backdrop="static"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                <i className="fas fa-user-edit"></i> Reschedule
              </h5>
              <button
                onClick={() => {
                  setComment("");
                  setSelectedProviders(null);
                }}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="reschudle_job" className="needs-validation" novalidate>
                <div className="form-group">
                  <strong className="mb-0">Select Slot</strong>

                  {/* <div className="card-body">
                    <div className="row">
                      <div className="col-lg-12 slotDates">
                        {slotDates?.map((item, index) => {
                          return (
                            <div className="visual-picker visual-picker-sm has-peek mr-2 mb-3">
                              <input
                                type="radio"
                                id={index + "date"}
                                value={item}
                                name="slot_date"
                                className="slot_input"
                                onChange={(e) => {
                                  console.log("e", e.target.value);
                                  const filteredData = slotData.filter(
                                    (item) => item.slotDate === e.target.value
                                  );

                                  setselectedSlot(null);
                                  setSlotsPreview(filteredData);
                                }}
                              />
                              <label
                                className="visual-picker-figure"
                                htmlFor={index + "date"}
                              >
                                <small className="visual-picker-content slotDate">
                                  {moment(item).format("dddd").slice(0, 3)}
                                </small>

                                <small className="visual-picker-content slotDay">
                                  {moment(item).format("D")}
                                </small>
                              </label>
                              <small
                                style={{
                                  position: "absolute",
                                  top: "21px",
                                  background: "yellow",
                                  padding: "0px 13px",
                                  right: "25%",
                                  borderRadius: "22px",
                                }}
                              ></small>
                            </div>
                          );
                        })}
                      </div>
                      <div className="col-lg-12 mt-4">
                        {slotsPreview &&
                          slotsPreview[0]?.slot?.map((item, index) => {
                            return (
                              <div className="visual-picker visual-picker-sm has-peek mr-2 mb-3">
                                <input
                                  type="radio"
                                  id={index}
                                  className="slot_input"
                                  required=""
                                  value={item?._id}
                                  name="time_slot[]"
                                  onChange={(e) => {
                                    setselectedSlot(item);
                                  }}
                                  checked={selectedSlot == item}
                                />
                                <label
                                  className="visual-picker-figure"
                                  htmlFor={index}
                                >
                                  <small className="visual-picker-content slot_span">
                                    {item?.slotTime}
                                  </small>
                                  {item?.surgCharges != 0 && (
                                    <small className="badge badge-warning surgeCharge_span">
                                      {item?.surgCharges}
                                    </small>
                                  )}
                                </label>
                                <small
                                  style={{
                                    position: "absolute",
                                    top: "21px",
                                    background: "yellow",
                                    padding: "0px 13px",
                                    right: "25%",
                                    borderRadius: "22px",
                                  }}
                                ></small>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div> */}
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 slotDates">
                        <input
                          type="date"
                          id="dateFilter"
                          className="form-control"
                          value={selectedDate}
                          onChange={(e) => {
                            setSelectedDate(e.target.value);

                            if (selectedGroup) {
                              getSlots(e.target.value, selectedGroup);
                            } else {
                              Swal.fire({
                                icon: "error",
                                title: "Error!",
                                text: "Please select parent category group",
                              });
                            }
                          }}
                        />
                      </div>
                      <div className="col-lg-12 mt-4 ">
                        {slotLoading ? (
                          <div className="text-center">
                            <div
                              class="spinner-border text-primary loader p-3 my-4 "
                              role="status"
                            >
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                        ) : (
                          <>
                            {slotsPreview &&
                              updatedData?.map((item, index) => {
                                let styles = {
                                  backgroundColor: "gray",
                                  color: "#fff",
                                };
                                return (
                                  <div
                                    key={index}
                                    className="visual-picker visual-picker-sm has-peek mr-2 mb-3"
                                  >
                                    <input
                                      type="radio"
                                      id={index + "time"}
                                      className="slot_input"
                                      checked={selectedSlot === item.slotTime}
                                      required=""
                                      value={item.slotTime}
                                      name="time_slot[]"
                                      onChange={(e) => {
                                        setselectedSlot(e.target.value);
                                        // setSurg(parseFloat(item?.surgCharges));
                                      }}
                                    />
                                    <label
                                      className="visual-picker-figure"
                                      htmlFor={index + "time"}
                                    >
                                      <small
                                        className="visual-picker-content slot_span"
                                        style={
                                          item?.statusButton == false &&
                                          selectedSlot != item.slotTime
                                            ? styles
                                            : null
                                        }
                                      >
                                        {item.slotTime}
                                      </small>
                                      {item.surgCharges !== 0 && (
                                        <small className="badge badge-warning surgeCharge_span">
                                          {item.surgCharges}
                                        </small>
                                      )}
                                    </label>
                                    <small
                                      style={{
                                        position: "absolute",
                                        top: "21px",
                                        background: "yellow",
                                        padding: "0px 13px",
                                        right: "25%",
                                        borderRadius: "22px",
                                      }}
                                    ></small>
                                  </div>
                                );
                              })}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label>Select SP</label>
                  <Select
                    isClearable
                    options={provider?.map((option) => ({
                      value: option._id,
                      label: option.Name,
                    }))}
                    onChange={handleSelectChange}
                    value={selectedProviders}
                  />
                </div>
                <div className="form-group">
                  <strong>Comment</strong>
                  <textarea
                    value={comment}
                    onChange={(e) => {
                      setComment(e.target.value);
                    }}
                    className="form-control"
                    name="reshedule_comment"
                    id="reshedule_comment"
                    placeholder="Add Comment"
                    rows="4"
                  ></textarea>
                </div>

                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-warning mr-2 mr-2"
                    data-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    onClick={() => {
                      console.log("slot date");
                      navigator.clipboard.writeText(JSON.stringify(selectedProviders));

                      let dataa = {
                        jobId: jobId,
                        action: "reschedule",
                        reasons: comment,
                        jobAssignSProviderId: selectedProviders?.value,
                        slotDate: selectedDate,
                        slotTime: selectedSlot,
                        types: "admin",
                        SPName: selectedProviders?.label,
                        // appointmentId: selectedSlot?._id,
                      };

                      ServiceProviderActions(dataa);
                    }}
                    type="button"
                    name="btnRescheduleJob"
                    className="btn btn-primary mr-2"
                    data-dismiss="modal"
                  >
                    Reschedule
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="closeJobModal"
        data-backdrop="static"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                <i className="fas fa-ban"></i> Close Job
              </h5>
              <button
                onClick={() => {
                  setComment("");
                }}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="close_job" className="needs-validation" novalidate>
                <div className="form-group">
                  <label>Amount</label>
                  <input
                    type="number"
                    id="txtPaybleAmount"
                    className="form-control"
                    placeholder="Amount"
                    value={amount}
                    readonly
                    name="txtPaybleAmount"
                  />
                </div>
                <div className="form-group">
                  <label>Tip</label>
                  <input
                    type="number"
                    id="txtPaybleAmount"
                    className="form-control"
                    placeholder="Amount"
                    value={selectedTip}
                    onChange={(e) => {
                      setSelectedTip(e.target.value);
                    }}
                    name="txtPaybleAmount"
                  />
                </div>
                <div className="form-group">
                  <label>Payment Mode</label>
                  <select
                    className="form-control"
                    name="cmbPaymentJob"
                    id="cmbPaymentJob"
                    required
                    value={paymentMode}
                    onChange={(e) => {
                      setPaymentMode(e.target.value);
                    }}
                  >
                    <option value="">Payment Mode</option>
                    <option>Paytm</option>
                    <option>Google Pay</option>
                    <option>Phone Pay</option>
                    <option>Cash</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Comment</label>
                  <textarea
                    className="form-control"
                    name="txtcomment"
                    id="txtcomment"
                    placeholder="Add Comment"
                    rows="4"
                    value={comment}
                    onChange={(e) => {
                      setComment(e.target.value);
                    }}
                  ></textarea>
                </div>

                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-warning mr-2"
                    data-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    data-dismiss="modal"
                    type="submit"
                    name="closeBtn"
                    className="btn btn-primary mr-2"
                    onClick={() => {
                      navigator.clipboard.writeText(JSON.stringify(selectedProviders));

                      let dataa = {
                        jobId: jobId,
                        action: "close",
                        reasons: comment,
                        payableCharges: amount,
                        tip: selectedTip,
                        payment_Mode: paymentMode,
                        types: "admin",
                      };
                      ServiceProviderActions(dataa);
                    }}
                  >
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="CancelJobModal"
        data-backdrop="static"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                <i className="fas fa-window-close"></i> Cancel Job
              </h5>
              <button
                onClick={() => {
                  setComment("");
                  setCancelCode("");
                }}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="cancel_job" className="needs-validation" novalidate>
                <div className="form-group">
                  <label>Select Type</label>
                  <select
                    className="form-control"
                    name="cmbCancelState"
                    id="cmbCancelState"
                    required
                    value={cancelCode}
                    onChange={(e) => {
                      setCancelCode(e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    <option value="canceled">Canceled</option>
                    <option value="cancel_IR">Canceled IR</option>
                    <option value="cancel_CR">Canceled CR</option>
                    <option value="cancel_NR">Canceled NR</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Comment</label>
                  <textarea
                    value={comment}
                    onChange={(e) => {
                      setComment(e.target.value);
                    }}
                    className="form-control"
                    name="CancelComment"
                    id="CancelComment"
                    placeholder="Add Comment"
                    rows="4"
                  ></textarea>
                </div>

                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-warning mr-2 mr-2"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(JSON.stringify(selectedProviders));

                      let dataa = {
                        jobId: jobId,
                        action: cancelCode,
                        reasons: comment,
                        types: "admin",
                      };
                      ServiceProviderActions(dataa);
                    }}
                    type="button"
                    name="cancelJob"
                    className="btn btn-primary mr-2"
                    data-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="yesNoactionModal"
        data-backdrop="static"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <button
              type="button"
              style={{
                zIndex: 999999999,
              }}
              onClick={() => {
                setComment("");
              }}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div className="modal-body py-3 pt-4">
              <form id="pause_job">
                <h4 className="card-title">{action}</h4>

                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-warning mr-2 mr-2"
                    data-dismiss="modal"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    name="btnPauseJob"
                    data-dismiss="modal"
                    aria-label="Close"
                    className="btn btn-primary mr-2"
                    onClick={() => {
                      navigator.clipboard.writeText(JSON.stringify(selectedProviders));

                      let dataa = {
                        jobId: id,
                        action: code,
                        reasons: fixedComment + adminName,
                        jobAssignSProviderId: selectedProviders?.value,
                        types: "admin",
                      };

                      ServiceProviderActions(dataa);
                    }}
                  >
                    Yes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="JobComment"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content text-left">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Job Comment
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setComment("");
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="add_comment_to_job" method="post">
                <input type="hidden" value="1715271391" name="txtHiddenJobID" />
                <div className="form-group">
                  <label>Comment</label>
                  <textarea
                    value={comment}
                    onChange={(e) => {
                      setComment(e.target.value);
                    }}
                    required
                    name="txtComment"
                    className="form-control"
                    rows="5"
                  ></textarea>
                </div>
                <div className="form-group">
                  <div className="custom-control custom-control-inline custom-checkbox">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="ckb2"
                      name="spCommentShow"
                      value="1"
                      checked={showSp ? true : false}
                      onChange={(e) => {
                        setshowSp(!showSp);
                      }}
                    />{" "}
                    <label className="custom-control-label" for="ckb2">
                      Service Provider
                    </label>
                  </div>
                </div>
                <input type="hidden" value="add_comment_to_job" name="action" />
                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-secondary mr-2"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(JSON.stringify(selectedProviders));

                      let dataa = {
                        jobId: id,
                        action: "comment",
                        reasons: comment,
                        showtoSp: showSp ? 1 : 0,
                        types: "admin",
                      };

                      ServiceProviderActions(dataa);
                    }}
                    type="submit"
                    name="btnAddComment"
                    className="btn btn-primary mr-2"
                    data-dismiss="modal"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="JobPenalty"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content text-left">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Job Penalty
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => {
                  setComment("");
                }}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="job_panality" method="post">
                <input
                  type="hidden"
                  value="1715271391"
                  id="txtHiddenJobID"
                  name="txtHiddenJobID"
                />
                <div className="form-group">
                  <label>Penalty Amount</label>
                  <input
                    value={amountt}
                    onChange={(e) => {
                      setAmountt(e.target.value);
                    }}
                    type="text"
                    name="txtPenalty"
                    className="form-control"
                    placeholder="Penalty Amount"
                  />
                </div>
                <div className="form-group">
                  <label>Comment</label>
                  <textarea
                    required
                    name="txtComment"
                    className="form-control"
                    rows="5"
                    value={comment}
                    onChange={(e) => {
                      setComment(e.target.value);
                    }}
                  ></textarea>
                </div>
                <input type="hidden" value="add_panility" name="action" />
                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-secondary mr-2"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(JSON.stringify(selectedProviders));

                      let dataa = {
                        jobId: id,
                        action: "comment",
                        reasons: comment,
                        jobPenalty: amountt,
                        types: "admin",
                      };

                      ServiceProviderActions(dataa);
                    }}
                    type="submit"
                    name="btnAddPenalty"
                    className="btn btn-primary mr-2"
                    data-dismiss="modal"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="spNote"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content text-left">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Special Note
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={() => {
                  setComment("");
                }}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="spNotes" method="post">
                <input
                  type="hidden"
                  value="9953930109"
                  id="txtHiddenJobID"
                  name="txtHiddenJobID"
                />
                <div className="form-group">
                  <label>Comment</label>
                  <textarea
                    value={comment}
                    onChange={(e) => {
                      setComment(e.target.value);
                    }}
                    required
                    name="txtComment"
                    className="form-control"
                    rows="5"
                  ></textarea>
                </div>
                <input type="hidden" value="add_spNote" name="action" />
                <div className="form-group">
                  <button
                    type="button"
                    className="btn btn-secondary mr-2"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    name="btnAddPenalty"
                    className="btn btn-primary mr-2"
                    data-dismiss="modal"
                    onClick={() => {
                      navigator.clipboard.writeText(JSON.stringify(selectedProviders));

                      let dataa = {
                        jobId: id,
                        action: "Jobnotes",
                        reasons: comment,
                        types: "admin",
                      };

                      ServiceProviderActions(dataa);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
